import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'kt-user-manual-viewer',
  templateUrl: './user-manual-viewer.component.html',
  styleUrls: ['./user-manual-viewer.component.scss']
})
export class UserManualViewerComponent implements OnInit {

  constructor() { }
  @Input() url: string;
  ngOnInit() {
  }

  public downloadPageManual(): void {
    window.open('./assets/pdf/user-manual.pdf')

  }
}
